{
  "next": "Siguiente",
  "nextStep": "Siguiente: {step}",
  "back": "Atrás",
  "backToStart": "Volver a la página de inicio",
  "submit": "Enviar",
  "submitContinue": "Continuar",
  "submitNextStepNote": "Registra tu solicitud de socio. En el siguiente paso eliges cómo activar la domiciliación.",
  "donationTypeMonthly": "Mensual",
  "donationTypeSingle": "Una vez",
  "amountLabel": "Importe",
  "customAmount": "Importe personalizado",
  "minAmount": "El importe mínimo es {min} {currency}",
  "perMonth": "{amount} kr/mes",
  "firstName": "Nombre",
  "lastName": "Apellido",
  "email": "Correo electrónico",
  "mobile": "Número de móvil",
  "ssn": "Número de identificación",
  "ssnPlaceholder": "AAAAMMDD-NNNN",
  "ssnHint": "Por ejemplo 19940906-2388, se usa para registrar tu donación e intentar obtener tu dirección postal.",
  "membershipSsnHint": "Por ejemplo 19940906-2388, se usa para registrar tu membresía e intentar obtener tu dirección postal.",
  "ssnMissingHelp": "¿No tienes personnummer o prefieres no darlo? Contacta con el servicio de donantes y te ayudamos:",
  "birthDate": "Fecha de nacimiento",
  "birthDateHint": "Una fecha de nacimiento, aaaa-mm-dd",
  "ssnOrBirthdateHint": "¿No tienes número de identidad personal sueco? Introduce tu fecha de nacimiento.",
  "birthDatePlaceholder": "aaaa-mm-dd",
  "selectCountry": "Seleccionar país",
  "street": "Dirección",
  "postcode": "Código postal",
  "city": "Ciudad",
  "country": "País",
  "consentHeader": "Firmar el mandato de domiciliación",
  "consentSubtitle": "Firma con BankID o recibe el mandato por correo",
  "consentBankid": "Firmar con BankID",
  "consentPostal": "Recibir mandato por correo",
  "bankidStarting": "Iniciando BankID …",
  "bankidPending": "Abre la app de BankID y firma",
  "bankidPendingIdentify": "Abre la app de BankID e identifícate",
  "bankidComplete": "Firma completada",
  "bankidFailed": "La firma se canceló",
  "bankidRetry": "Inténtalo de nuevo",
  "openBankid": "Abrir BankID",
  "errorGeneric": "Algo salió mal. Inténtalo de nuevo.",
  "formClosed": "Esta recaudación está cerrada.",
  "formTryAgain": "Algo salió mal momentáneamente. Inténtalo de nuevo en un momento.",
  "errorModalTitle": "¡Vaya, algo ha salido mal!",
  "errorModalRetry": "Inténtalo de nuevo",
  "errorModalContact": "Puedes contactar con el servicio de donantes:",
  "alreadyMemberTitle": "Ya es socio",
  "required": "Este campo es obligatorio",
  "invalidEmail": "Correo electrónico no válido",
  "invalidClearing": "El número de compensación debe tener 4 dígitos",
  "invalidAccount": "El número de cuenta debe tener entre 4 y 12 dígitos",
  "invalidSsn": "Número de identificación no válido",
  "invalidMobile": "Número de móvil no válido",
  "invalidPostcode": "Código postal no válido",
  "minorDisclaimer": "You must be at least 18 to become a monthly donor. You can instead ",
  "minorLinkYouth": "become an annual member.",
  "minorLinkChild": "join the Rädda Djuren club.",
  "giftTitle": "¿Qué regalo de bienvenida te gustaría?",
  "giftSubtitle": "El regalo se te enviará por correo",
  "skipGift": "No quiero un regalo",
  "enlargeGiftImage": "Ver imagen más grande: {title}",
  "chooseThisGift": "Elegir regalo",
  "bankidSignMessage": "Apruebo una donación de {amount} SEK a Djurens Rätt cada mes, pagada mediante débito directo (autogiro). Puede cancelarse en cualquier momento contactando con Djurens Rätt.",
  "bankidSignMessageNoAmount": "Apruebo un mandato de débito directo (autogiro) para Djurens Rätt. Puede cancelarse en cualquier momento contactando con Djurens Rätt.",
  "thankYouTitle": "¡Gracias por tu apoyo!",
  "thankYouTitleCompany": "¡Gracias por su apoyo!",
  "lookupCta": "Obtener mis datos",
  "lookupPending": "Obteniendo …",
  "lookupNotFound": "No se encontraron datos — complétalos manualmente",
  "consentLinkNotFound": "No hemos encontrado ningún consentimiento para firmar con este enlace. Comprueba que has usado el enlace completo de nuestro mensaje, o contáctanos y te ayudaremos.",
  "lookupConfirm": "Encontramos tus datos:",
  "lookupManual": "Introducir manualmente",
  "lookupInstead": "Obtener mis datos",
  "enterManually": "Introducir número de cuenta manualmente",
  "manualFallbackPrompt": "¿Prefieres",
  "manualFallbackLink": "introducir los datos de tu cuenta manualmente",
  "accountFetchPrompt": "¿Cómo quieres indicar tu cuenta?",
  "useAccountConfirm": "Usar esta cuenta",
  "bank": "Banco",
  "bankSelect": "Elige tu banco",
  "bankOther": "Otro banco",
  "fetchAccounts": "Obtener cuenta desde tu banco",
  "fetchingAccounts": "Obteniendo cuenta …",
  "accountsFailed": "No se pudo obtener la cuenta",
  "clearing": "Número de clearing",
  "account": "Número de cuenta",
  "changeAccountPrefix": "¿Cuenta incorrecta? Puedes",
  "changeAccountManual": "introducirla manualmente",
  "changeAccountOr": "o",
  "changeAccountFetch": "obtener otra cuenta",
  "clearingHint": "Normalmente 4 dígitos. Sparbankerna/Swedbank tienen 5 (NNNN-N): introdúcelo sin guion.",
  "sparbankWarning": "Asegúrate de elegir la opción correcta entre Sparbanken Syd, Swedbank o Swedbank Sparbankerna. Si una opción no funciona, prueba con otra.",
  "flowTitle": "Hazte socio mensual",
  "progressLabel": "Progreso",
  "stepOf": "Paso {step} de {total}",
  "stepAmount": "Importe",
  "stepGift": "Regalo",
  "stepDetails": "Tus datos",
  "stepAddress": "Dirección",
  "stepConsent": "Mandato",
  "stepPayment": "Pago",
  "thankYouBody": "Ahora eres socio mensual. Juntos marcamos la diferencia por los animales.",
  "thankYouBodyCompany": "Ahora son socios mensuales. Juntos marcamos la diferencia por los animales.",
  "donate": "Dona",
  "donationFlowTitle": "Haz una donación",
  "choosePayment": "¿Cómo quieres pagar?",
  "choosePaymentCompany": "¿Cómo desean pagar?",
  "paySwish": "Swish",
  "paySwishDesc": "Paga al instante con Swish",
  "payCard": "Tarjeta",
  "payCardDesc": "Paga con tarjeta",
  "payPostal": "Factura",
  "payPostalDesc": "Recibe una factura por correo",
  "redirecting": "Te estamos redirigiendo al pago …",
  "redirectingCompany": "Les estamos redirigiendo al pago …",
  "donationCancelled": "El pago se canceló. Puedes intentarlo de nuevo.",
  "donationThankYouTitle": "¡Gracias por tu donación!",
  "donationThankYouTitleCompany": "¡Gracias por su donación!",
  "donationThankYouBody": "Tu donación marca la diferencia para los animales.",
  "donationPostalBody": "Tu factura se enviará por correo. ¡Gracias por tu donación!",
  "integrityText": "Para gestionar tu afiliación e informarte sobre nuestro trabajo por los animales, guardamos la información que proporcionas. Lo hacemos de acuerdo con el reglamento general de protección de datos, lo que garantiza que tus datos estén protegidos y no se divulguen a nadie más.",
  "integrityTextDonation": "Para gestionar tu donación y mantenerte informado sobre nuestro trabajo por los animales, guardamos los datos que nos facilitas. Lo hacemos conforme al reglamento de protección de datos, lo que significa que garantizamos que tus datos están protegidos y no se ceden a terceros.",
  "integrityTextDonationCompany": "Para gestionar su donación y mantenerles informados sobre nuestro trabajo por los animales, guardamos los datos que nos facilitan. Lo hacemos conforme al reglamento de protección de datos, lo que significa que garantizamos que sus datos están protegidos y no se ceden a terceros.",
  "integrityTextPetition": "Para registrar tu firma e informarte sobre nuestro trabajo por los animales, guardamos los datos que nos facilitas. Tu nombre y, en su caso, tu comentario constituyen la firma que entregamos en la campaña. Tratamos los datos conforme al reglamento de protección de datos, lo que garantiza que estén protegidos y no se cedan de ninguna otra forma.",
  "integrityTextActivist": "Para registrarte como persona voluntaria digital e informarte sobre nuestro trabajo por los animales, guardamos los datos que nos facilitas. Lo hacemos conforme al reglamento de protección de datos, lo que garantiza que tus datos estén protegidos y no se cedan a terceros.",
  "integrityMore": "Lee más en nuestra política de integridad",
  "integrityMoreLink": "política de integridad",
  "integrityUrl": "https://es.project1882.org/politica",
  "annualFlowTitle": "Hazte socio anual",
  "stepCategory": "Afiliación",
  "chooseCategory": "¿Qué afiliación quieres?",
  "categoryOrdinary": "Cuota ordinaria: 330 kr",
  "categoryOrdinaryDesc": "El mayor apoyo para los animales❤️ Únete y marca una diferencia mayor por ellos.",
  "categoryReduced": "Cuota reducida: 150 kr",
  "categoryReducedDesc": "Para quienes tienen 18-25 años, son pensionistas o reciben prestación por enfermedad.",
  "categoryYouth": "Cuota gratuita: 0 kr",
  "categoryYouthDesc": "Para quienes tienen 14-17 años y quieren implicarse por los animales.",
  "membershipTabDjurensRatt": "Djurens Rätt",
  "membershipTabChild": "Para niños",
  "membershipDjurensRattTitle": "Membresía en Djurens Rätt",
  "membershipDjurensRattSubtitle": "Incluye 4 revistas para socios al año. La membresía se renueva anualmente.",
  "membershipChildTitle": "Membresía en Rädda Djuren-klubben",
  "membershipChildSubtitle": "Un año de membresía en Rädda Djuren-klubben es el regalo perfecto para el niño al que le importan los animales. Incluye 5 revistas al año y un bonito regalo que puedes dar al nuevo socio.",
  "membershipChildNote": "Pulsa el botón de abajo para continuar en la web de Rädda Djuren-klubben.",
  "youthBirthdateHint": "Introduce tu número de identidad personal o tu fecha de nacimiento para confirmar que tienes entre 14 y 17 años.",
  "youthAgeError": "La membresía juvenil es para personas de 14 a 17 años. Elige otra membresía.",
  "youthFreeNote": "La afiliación juvenil es gratuita: no tienes que pagar nada.",
  "becomeMember": "Hazte socio",
  "annualThankYouTitle": "¡Bienvenido como socio!",
  "annualThankYouBody": "Gracias por hacerte socio anual. Juntos marcamos la diferencia por los animales.",
  "annualPostalBody": "Tu factura se enviará por correo. ¡Bienvenido como socio!",
  "annualYouthBody": "Tu afiliación juvenil ya está registrada. ¡Bienvenido!",
  "alreadyMember": "Ya eres socio. Contacta con el servicio de atención a donantes si tienes preguntas sobre tu afiliación.",
  "notYouFillIn": "¿No eres tú? Rellena tus propios datos",
  "giftedFlowTitle": "Regala un donativo",
  "stepGiftImage": "Motivo",
  "stepGiftDetails": "Mensaje",
  "stepDelivery": "Entrega",
  "giftcertTitle": "Nombre del destinatario",
  "giftcertChooseTitle": "¿Qué tarjeta quieres enviar?",
  "giftcertChooseSubtitle": "Elige un motivo",
  "giftcertTitlePlaceholder": "¿Para quién es el regalo?",
  "giftcertMessage": "Tu mensaje",
  "giftcertMessageHint": "Escribe un mensaje personal que se imprimirá en el certificado de regalo. No olvides indicar quién lo envía. No se pueden usar emojis.",
  "giftcertCharsLeft": "Quedan {count} caracteres",
  "giftcertMessageNoEmoji": "El mensaje no puede contener emojis.",
  "giftcertMessageTooLong": "El mensaje puede tener como máximo {max} caracteres.",
  "memorialHonoreeName": "Nombre de la persona que deseas honrar",
  "memorialHonoreeNameError": "Introduce el nombre de la persona que deseas honrar",
  "deliveryTitle": "¿Cómo quieres entregar el certificado?",
  "deliveryDigital": "Digital",
  "deliveryPrinted": "Impreso",
  "deliveryDigitalText": "El certificado se envía como PDF a tu correo justo después de pagar.",
  "deliveryEmail": "Tu dirección de correo electrónico",
  "deliveryPrintedText": "Imprimimos y enviamos por correo el certificado de regalo.",
  "deliveryRecipientHeading": "¿Quién debe recibir el certificado?",
  "deliveryMailToMe": "Enviarme el certificado a mí",
  "deliverySendWhen": "¿Cuándo debe enviarse la tarjeta?",
  "deliverySendNow": "Lo antes posible",
  "deliverySendDate": "Elegir fecha de envío",
  "deliverySendDateLabel": "Fecha de entrega",
  "deliveryDateInvalid": "Elige una fecha a partir de hoy",
  "deliveryEstimate": "Entrega estimada entre {range}.",
  "deliveryToMeTitle": "Envío por correo a ti",
  "deliveryToMeText": "El certificado de regalo se envía por correo a ti y debería llegar en un plazo de cinco días laborables.",
  "deliveryToRecipientTitle": "Envío por correo al destinatario",
  "deliveryToRecipientText": "El certificado de regalo se envía por correo al destinatario y debería llegar en un plazo de cinco días laborables desde la fecha de envío elegida.",
  "deliveryOr": "o",
  "deliveryNote": "Ten en cuenta que la entrega tarda de 3 a 5 días laborables. Puede verse afectada por el servicio postal y los días festivos.",
  "deliveryLastDateInfo": "Para garantizar la entrega antes de {message}, pide antes del {date}.",
  "deliveryAfterLastDate": "Ya no podemos garantizar la entrega antes de {message}.",
  "deliverySwitchDigital": "Elige la entrega digital: el certificado se envía por correo electrónico justo después del pago.",
  "giftcertThankYouTitle": "¡Gracias por tu donativo!",
  "giftcertThankYouBody": "Tu certificado de regalo está en camino. Gracias por regalar un donativo a los animales.",
  "giftcertPostalBody": "Tu factura se enviará por correo. ¡Gracias por tu donativo!",
  "companyName": "Nombre de la empresa",
  "organisationNumber": "Número de registro",
  "invoiceEmail": "Correo electrónico para la factura",
  "stepCompany": "Empresa",
  "perMonthSuffix": "/mes",
  "payInvoice": "Factura",
  "payInvoiceDesc": "Recibe una factura por correo electrónico",
  "companyDonationFlowTitle": "Haz una donación de empresa",
  "recurringFlowTitle": "Hazte socio mensual",
  "companyRecurringFlowTitle": "Hazte socio mensual como empresa",
  "recurringThankYouTitle": "¡Gracias por tu apoyo mensual!",
  "recurringThankYouTitleCompany": "¡Gracias por su apoyo mensual!",
  "invoiceThankYouBody": "Tu factura está en camino. ¡Gracias por apoyar a los animales!",
  "invoiceThankYouBodyCompany": "Su factura está en camino. ¡Gracias por apoyar a los animales!",
  "giftedMembershipFlowTitle": "Regala una membresía del Rädda Djuren-klubben",
  "stepChild": "Destinatario",
  "childDetailsTitle": "¿Quién será socio?",
  "childFirstName": "Nombre del niño",
  "childLastName": "Apellido del niño",
  "childBirthDate": "Fecha de nacimiento del niño",
  "childBirthDateHint": "El niño debe tener 13 años o menos",
  "childMustBeChild": "El niño debe tener 13 años o menos para unirse al club.",
  "sameAddressAsMe": "El niño vive en la misma dirección que yo",
  "agentMustBeAdult": "Debes tener al menos 18 años para regalar una membresía.",
  "becomeChildMember": "Regalar membresía",
  "giftedMembershipThankYouTitle": "¡Gracias por tu regalo!",
  "giftedMembershipThankYouBody": "La membresía del Rädda Djuren-klubben está en camino. Gracias por dar al niño la oportunidad de ayudar a los animales.",
  "giftedMembershipPostalBody": "Tu factura se enviará por correo. ¡Gracias por regalar una membresía!",
  "giftedAnnualStepRecipient": "Destinatario",
  "giftedAnnualStepGiftCard": "Certificado de regalo",
  "giftedAnnualRecipientTitle": "¿Para quién es la membresía?",
  "giftedAnnualRecipientSsn": "Número de identificación del destinatario",
  "giftedAnnualRecipientLookupConfirm": "Encontramos los datos del destinatario:",
  "giftedAnnualRecipientSsnHint": "Por ejemplo 19940906-2388, se usa para registrar la membresía a la persona correcta e intentar obtener su dirección postal.",
  "giftedAnnualRecipientFirstName": "Nombre del destinatario",
  "giftedAnnualRecipientLastName": "Apellidos del destinatario",
  "giftedAnnualRecipientBirthDate": "Fecha de nacimiento del destinatario",
  "giftedAnnualSameAddress": "El destinatario vive en la misma dirección que yo",
  "giftedAnnualCategoryTitle": "¿Qué membresía recibirá el destinatario?",
  "giftedAnnualPresentTitle": "¿Qué regalo de bienvenida quieres dar?",
  "giftedAnnualGiftCardTitle": "¿Qué certificado de regalo quieres dar?",
  "giftedAnnualGiftCardSubtitle": "Te enviaremos el certificado de regalo por correo.",
  "giftedAnnualBuyerTitle": "¿Quién eres tú, que regalas la membresía?",
  "giftedAnnualSubmit": "Regalar la membresía",
  "giftedAnnualThankYouTitle": "¡Gracias por regalar una membresía!",
  "giftedAnnualThankYouBody": "Juntos marcamos la diferencia por los animales.",
  "giftedAnnualPostalBody": "La factura se te enviará por correo.",
  "giftedAnnualYouthBody": "La membresía juvenil está registrada.",
  "giftedAnnualAlreadyMember": "El destinatario ya es socio de Djurens Rätt. Contacta con el servicio de atención a donantes si tienes alguna pregunta.",
  "raiseAmountTitle": "Aumenta tu cuota mensual",
  "raiseAmountIntro": "Como donante mensual de Djurens Rätt puedes aumentar fácilmente tu cuota mensual.",
  "raiseAmountIdentifyTitle": "Identifícate",
  "raiseAmountIdentifyIntro": "Inicia sesión con BankID y recuperaremos tu membresía.",
  "raiseAmountIdentifyCta": "Identifícate con BankID",
  "raiseAmountChooseTitle": "Elige una nueva cuota mensual",
  "raiseAmountCurrent": "Tu cuota actual: {amount} kr/mes",
  "raiseAmountSameError": "Es la misma cantidad que antes. Elige una cantidad diferente.",
  "raiseAmountMustBeHigher": "Ya das {current} {currency}/mes. Elige una cantidad mayor para aumentarla.",
  "raiseAmountMustBeHigherUnknown": "La nueva cantidad debe ser mayor que la actual.",
  "raiseAmountUnavailable": "No pudimos confirmar si el cambio se aplicó. Inténtalo de nuevo en unos minutos: volver a enviar el mismo importe no cambia nada si ya se había aplicado.",
  "raiseAmountNotFound": "No encontramos tu membresía. Revisa tus datos e inténtalo de nuevo.",
  "raiseAmountSubmit": "Confirmar nueva cantidad",
  "raiseAmountSuccessTitle": "Tu cuota mensual ha cambiado",
  "raiseAmountSuccessBody": "Tu nueva donación mensual es {amount} kr/mes. ¡Gracias por tu apoyo!",
  "raiseAmountAltToggle": "Identify yourself another way",
  "raiseAmountHelp": "Stuck? Email",
  "raiseAmountAltMemberNumberHint": "Your member number is in our letters and on the back of the Djurens Rätt magazine.",
  "raiseAmountAltMobileHint": "The number you have registered with us, e.g. +46xxxxxxxxx.",
  "raiseAmountAltCodeHint": "The six-digit code in the text message.",
  "raiseAmountAltEmailHint": "The address you have registered with us.",
  "raiseAmountAltSsnHint": "For example 19940906-2388, used to confirm it is you.",
  "raiseAmountAltInvalidCode": "The code is six digits.",
  "raiseAmountAltTabSms": "Text code",
  "raiseAmountAltTabEmail": "Email link",
  "raiseAmountAltTabMember": "Member number",
  "raiseAmountAltMobileLabel": "Mobile number",
  "raiseAmountAltSmsCta": "Send code",
  "raiseAmountAltSmsSent": "If we have {mobile}, we have sent a code to it. The code is valid for 10 minutes.",
  "raiseAmountAltCodeLabel": "Code",
  "raiseAmountAltCodeCta": "Sign in",
  "raiseAmountAltWrongCode": "The code is not right. Check it and try again.",
  "raiseAmountAltCodeExpired": "The code has expired. Ask for a new one.",
  "raiseAmountAltEmailLabel": "Email address",
  "raiseAmountAltEmailCta": "Send link",
  "raiseAmountAltEmailSent": "If we have {email}, we have sent a link to it. The link is valid for 30 minutes.",
  "raiseAmountAltLinkExpired": "The link has expired. Sign in again below.",
  "raiseAmountSignedInAs": "Signed in as {name}",
  "raiseAmountNotYou": "Not you?",
  "raiseAmountAltMemberNumberLabel": "Membership number",
  "raiseAmountAltSsnLabel": "Personal identity number",
  "raiseAmountAltMemberCta": "Sign in",
  "raiseAmountAltMemberNoMatch": "The membership number and personal identity number do not match. Check them and try again.",
  "raiseAmountAltRateLimited": "You have tried too many times. Wait a while and try again.",
  "raiseAmountAltChangeMobile": "Change number",
  "raiseAmountAltUnavailable": "We couldn't sign you in just now. Please try again in a moment.",
  "recommended": "Recomendado",
  "surveyBack": "Atrás",
  "surveyBlixtCta": "Suscríbete a Blixtmail",
  "surveyBlixtSendsTo": "Blixtmail se enviará a {email}.",
  "surveyBlixtTitle": "Hazte Blixt: actúa digitalmente por los animales",
  "surveyBlixtBody": "Como persona voluntaria digital realizas acciones rápidas por los animales en línea: pequeñas tareas que marcan una diferencia real. Recibirás las tareas por correo y también puedes usar nuestra BlixtApp, que se llena continuamente de actividades.",
  "surveyBlixtMoreLabel": "¿Qué hace una persona voluntaria digital?",
  "surveyBlixtFact1": "Firma peticiones por los animales",
  "surveyBlixtFact2": "Envía correos exprés a empresas y responsables políticos",
  "surveyBlixtFact3": "Comparte y difunde mensajes en redes sociales",
  "surveyBlixtDone": "¡Gracias! Ahora eres Blixt.",
  "surveyBlixtOpenApp": "Abrir la BlixtApp",
  "surveyBlixtError": "Algo salió mal. Inténtalo de nuevo.",
  "surveyChannelEmail": "correo electrónico",
  "surveyQuestionBadge": "Pregunta {n}",
  "surveyAmountChip": "{amount} SEK",
  "surveyAmountGroupSwish": "Dona una vez con Swish",
  "surveyAmountGroupMonthly": "Dona cada mes",
  "surveyShareDecline": "No, gracias",
  "surveyShareVia": "vía",
  "surveyShareLinkLabel": "Enlace para compartir",
  "surveyShareCopy": "Copiar el enlace",
  "surveyShareCopied": "Enlace copiado",
  "opensInNewTab": "(se abre en una pestaña nueva)",
  "petitionStepMessage": "Mensaje",
  "petitionMessagePlaceholder": "Escribe un mensaje (opcional)",
  "petitionMessageLabel": "Tu mensaje",
  "petitionNewsletterOptIn": "Sí, quiero recibir el boletín",
  "petitionSubmit": "Firmar la petición",
  "petitionThankYouTitle": "¡Gracias por firmar!",
  "petitionThankYouBody": "Tu firma ha sido registrada.",
  "petitionAlreadySigned": "Ya has firmado.",
  "petitionErrorMessage": "Algo salió mal. Por favor, inténtalo de nuevo.",
  "loading": "Cargando",
  "secondAskSigningAs": "Firmando como",
  "secondAskPetitionTitle": "Firma la petición",
  "petitionMotivationLabel": "Cuéntanos por qué firmas (opcional, se muestra aquí en la página)",
  "petitionBlixtmailOptIn": "Sí, quiero recibir Blixtmail una vez por semana con ideas de acciones por los animales.",
  "petitionProgressLabel": "{count} firmas: ¡ahora vamos a por {goal}!",
  "secondAskAlreadySigned": "Ya has firmado",
  "secondAskDonateWithSwish": "Pagar {amount} {currency} con Swish",
  "secondAskDonateWithCard": "Pagar {amount} {currency} con tarjeta",
  "secondAskSwishTo": "La solicitud de Swish se envía a {mobile}.",
  "secondAskSwishChange": "Cambiar número",
  "secondAskSwishWrongNumber": "¿Número equivocado? Cámbialo",
  "secondAskPaymentCancelled": "El pago se canceló. Inténtalo de nuevo o cambia el número si era incorrecto.",
  "secondAskBecomeMonthly": "Hazte donante mensual de {amount} kr/mes",
  "secondAskRaiseTo": "Subir a {amount} kr/mes",
  "secondAskCurrentMonthly": "Actualmente donas {amount} kr/mes",
  "secondAskDonorAs": "Donando como",
  "secondAskMembershipSuccess": "¡Bienvenido/a como donante mensual!",
  "secondAskRaiseSuccess": "Tu importe mensual ha sido actualizado",
  "secondAskDonationTitle": "Apoya a los animales con un donativo",
  "secondAskMonthlyTitle": "Hazte socio mensual",
  "shopBuyNow": "Comprar ahora",
  "shopSoldOut": "Agotado",
  "shopViewInStore": "Ver en la tienda",
  "shopVariant": "Variante",
  "shopNoProducts": "No hay productos para mostrar ahora.",
  "shopMemberPrice": "Precio socio",
  "bankidQrEnlargedTitle": "Escanea el código QR",
  "bankidQrEnlargedLabel": "Código QR de BankID ampliado",
  "bankidQrEnlargedHint": "Abre la aplicación BankID en tu teléfono y escanea el código.",
  "bankidQrAlt": "Código QR para escanear con la aplicación BankID",
  "bankidEnlargeQr": "Ampliar el código QR",
  "bankidExtend": "Ampliar el tiempo",
  "bankidExpired": "Se acabó el tiempo",
  "close": "Cerrar",
  "actStepStart": "Información",
  "actStepAmount": "Donación",
  "actStepDetails": "Información personal",
  "actStepAddress": "Dirección postal",
  "actStepPayment": "Opciones de pago",
  "actAmountTitle": "¿Cuánto te gustaría donar por los animales?",
  "actDetailsTitle": "Tu información de pago",
  "actDetailsSubtitle": "Rellena las casillas",
  "actAddressTitle": "¿Cuál es tu dirección postal?",
  "actAddressSubtitle": "Datos recuperados",
  "actAddressSubtitleManual": "Rellena las casillas",
  "actPaymentTitle": "¿Cómo te gustaría pagar tu regalo a los animales?",
  "actPaymentSubtitle": "Elija su método de pago",
  "actPaymentTitleSingle": "Todo está listo",
  "actPaymentSubtitleSingle": "Hagamos esa donación para los animales",
  "actAmountEyebrow": "Mi donación por los animales",
  "actAmountEyebrowCompany": "Nuestra donación por los animales",
  "actAmountHint": "Elige la cantidad",
  "actAmountOther": "Otro",
  "actAmountCustomLabel": "Elige la cantidad",
  "actAmountCustomLabelCompany": "Elijan la cantidad",
  "actSingle": "Donación única",
  "actMonthly": "Donación mensual",
  "actSsnPlaceholder": "aaaammdd-nnnn",
  "actSsnHint": "Un número de seguridad social sueco (personnummer), aaaammdd-nnnn",
  "actNoSsn": "No tengo un número de seguridad social sueco",
  "actHasSsn": "Tengo un número de seguridad social sueco",
  "actBirthDateHint": "Una fecha de nacimiento, aaaa-mm-dd",
  "actMobileHint": "Introduce tu número sin barras ni espacios, por ejemplo +34xxxxxxxxx",
  "actFillOther": "Rellene otros detalles",
  "actLookupName": "Nombre",
  "actLookupChangeAddress": "Rellene otros detalles",
  "actLookupUseFetched": "Usar los datos recuperados",
  "actLookupBannerPending": "Obteniendo tus datos …",
  "actLookupBannerFound": "¡Hemos encontrado tus datos!",
  "actLookupBannerFailed": "No se pudieron obtener los datos de dirección.",
  "actPaySwish": "Swish",
  "actPaySwishDesc": "¡Suave y fácil, lo recomendamos!",
  "actPayCard": "Tarjeta",
  "actPayCardDesc": "Cargado directamente, ¡sin problemas!",
  "actPayCardDescCompany": "Cargado directamente, ¡sin problemas!",
  "actPayPostal": "Factura",
  "actPayPostalDesc": "Recibe una factura por correo",
  "actPayBySwish": "Pagar con Swish",
  "actPayByCard": "Pagar con tarjeta",
  "actPayByPostal": "Pagar",
  "actReadMore": "Leer más",
  "videoPlay": "Reproducir el video",
  "videoPause": "Pausar el video",
  "completing": "Un momento …",
  "actConsentTitle": "Firma tu autorización de domiciliación",
  "actConsentSubtitle": "Elige cómo quieres firmar",
  "actConsentBankid": "BankID",
  "actConsentBankidDesc": "Firma fácilmente con BankID",
  "actConsentPostal": "Formulario en papel",
  "actConsentPostalDesc": "Recibe un formulario por correo",
  "actBankTitle": "Obtener cuenta bancaria",
  "actBankTitleManual": "Introduce tus datos bancarios",
  "actBankTitleFetched": "Tus datos bancarios obtenidos",
  "actBankSubtitle": "La domiciliación solo funciona con algunas cuentas; comprueba con tu banco que la tuya la admite",
  "actSignTitle": "Firma con BankID",
  "actSignSubtitle": "Al firmar acepto estas condiciones",
  "actConsentOtherMethod": "Elige otra forma de firmar",
  "actMonthlyStepAmount": "Importe",
  "actMonthlyStepAddress": "Dirección",
  "actPerMonthSuffix": "/mes",
  "actStepBank": "Banco",
  "actStepSign": "Firmar"
}
